import React from "react";
import { Row, Col } from "react-bootstrap";
import ControlsMap from "../../../../Properties/PropertiesConfiguration";
import AdvanceThemeJson from "./ThemePropertiesJson/AdvanceThemeJson";
import style from "../ThemesLayout.module.css";
import ColorPicker from "../../../../../ReusableComponents/ColorPicker/ColorPicker";
import ToggleBtn from "../../../../../ReusableComponents/ToggleBtn/ToggleBtn";
import { useTranslation } from "react-i18next";

const DropdownComponent = (props) => {
  const { t } = useTranslation();
  const translationStyles =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  const propertyName = props.propertyName;
  const selectedOption = props.selectedOption;
  const details = props.propertyDetails;

  function handleCombo(comboId) {
    var select = document.getElementById(comboId);
    var propertyName = select.getAttribute("name");
    var optionTag = select.options[select.selectedIndex];
    props.handleProperty(propertyName, optionTag.value);
  }
  function handleToggle(e, field) {
    var value = e.target.value;
    if (field === "Show Border")
      props.handleProperty("TabAppearanceShowBorder", value);
    else props.handleProperty(field, value);
  }
  const sketchPickerCustomStyle = { position: "absolute", right: "1px" };

  return (
    <>
      {propertyName &&
      ControlsMap &&
      ControlsMap[propertyName] &&
      (ControlsMap[propertyName].type === "combo" ||
        ControlsMap[propertyName].type === "button") ? (
        <Row className={style.styleProperties} style={props.selectDivStyle}>
          <Col
            className={[style.styleLabel].join(" ")}
            style={props.selectLabelStyle}
          >
            {details && details.label
              ? t(`translation:${details.label}`)
              : t(`translation:${ControlsMap[propertyName].label}`)}
          </Col>
          <Col
            className={[style.styleOptions].join(" ")}
            h="9"
            style={props.selectColumnStyle}
          >
            <select
              className={[
                style.dropdownStyle,
                AdvanceThemeJson["smallDropdownList"] &&
                AdvanceThemeJson["smallDropdownList"].includes(propertyName)
                  ? style.smallDropdownStyle
                  : null,
              ].join(" ")}
              style={props.selectStyle}
              name={propertyName}
              id={propertyName}
              onChange={() => handleCombo(propertyName)}
            >
              {ControlsMap[propertyName].children.map(
                (optionTagData, optionCount) => {
                  if (ControlsMap[propertyName].children[optionCount].Title) {
                    if (
                      selectedOption ===
                      ControlsMap[propertyName].children[optionCount].Value
                    ) {
                      return (
                        <option
                          value={
                            ControlsMap[propertyName].children[optionCount]
                              .Value
                          }
                          selected
                        >
                          {propertyName === "ThemeDateFormat2" || propertyName === "ThemeDateFormat" || propertyName === "LabelRatio"  ? (
                             ControlsMap[propertyName].children[optionCount]
                             .Title
                          ): (
                            t(
                              ControlsMap[propertyName].children[optionCount]
                                .Title
                            )
                          )}
                        </option>
                      );
                    } else {
                      return (
                        <option
                          value={
                            ControlsMap[propertyName].children[optionCount]
                              .Value
                          }
                        >
                         {propertyName === "ThemeDateFormat2" || propertyName === "ThemeDateFormat" || propertyName ==="LabelRatio" ? (
                             ControlsMap[propertyName].children[optionCount]
                             .Title
                          ): (
                            t(
                              ControlsMap[propertyName].children[optionCount]
                                .Title
                            )
                          )}
                        </option>
                      );
                    }
                  }
                }
              )}
            </select>
          </Col>
        </Row>
      ) : propertyName &&
        ControlsMap &&
        ControlsMap[propertyName] &&
        ControlsMap[propertyName].type === "textarea" ? (
        <Row className={style.styleProperties} style={props.selectDivStyle}>
          <Col
            className={[style.styleLabel].join(" ")}
            style={props.selectLabelStyle}
          >
            {details && details.label
              ? t(`translation:${details.label}`)
              : t(`translation:${ControlsMap[propertyName].label}`)}
          </Col>
          <Col
            className={[style.styleOptions].join(" ")}
            h="9"
            style={props.selectColumnStyle}
          >
            <input
              aria-label={"Control Value1"}
              type="text"
              defaultValue={selectedOption}
              className={style.textboxStyle}
              onBlur={(event) =>
                props.handleProperty(propertyName, event.target.value)
              }
            />
          </Col>
        </Row>
      ) : propertyName &&
        ControlsMap &&
        ControlsMap[propertyName] &&
        ControlsMap[propertyName].type === "colorpicker" &&
        props.headerBackgroundColor !== "true" ? (
        <Row className={style.styleProperties}>
          <Col className={style.styleLabel}>
            {details && details.label
              ? t(`translation:${details.label}`)
              : t(`translation:${ControlsMap[propertyName].label}`)}
          </Col>
          <Col className={style.styleOptions}>
            <ColorPicker
              key={selectedOption}
              color={selectedOption !== undefined ? selectedOption : "#FFFFFF"}
              colorPickerInnerBoxStyle={{ left: "10px" }}
              colorPickerParentDiv={{ position: "relative" }}
              sketchPickerCustomStyle={
                translationStyles
                  ? { position: "absolute", left: "0px", zIndex: 1 }
                  : { position: "absolute", right: "0px" }
              }
              propertyName={details && details.key ? details.key : propertyName}
              presetColors={props.presetColors}
              handleProperty={(arg1, arg2) => props.handleProperty(arg1, arg2)}
            />
          </Col>
        </Row>
      ) : propertyName &&
        ControlsMap &&
        ControlsMap[propertyName] &&
        ControlsMap[propertyName].type === "toggle" ? (
        <Row className={style.styleProperties}>
          <Col className={style.styleLabel}>
            {details && details.label
              ? t(`translation:${details.label}`)
              : t(`translation:${ControlsMap[propertyName].label}`)}
          </Col>
          <Col className={style.styleOptions}>
            <ToggleBtn
              toggleState={selectedOption}
              handleToggle={handleToggle}
              field={details && details.label ? details.label : propertyName}
            />
          </Col>
        </Row>
      ) : props.headerBackgroundColor &&
        props.headerBackgroundColor === "true" ? (
        <div tabIndex={0} className={style.headerBackgoundColorDiv}>
          <Col className={style.headerBackgoundDecription} id='themeDropdownImage'>
            <div className={style.headerBackgoundDecriptionTitle}>
              {t(`${details.label}`)}
            </div>
            <img
              src={
                translationStyles
                  ? details?.imgSrc1?.default
                  : details?.imgSrc?.default
              }
              style={details.imgStyle}
              alt="img"
            />
          </Col>
          <Col className={style.headerBackgroundColorBoxCol}>
            <div
              className={style.headerBackgroundColorBox}
              style={
                translationStyles
                  ? { marginLeft: "unset", marginRight: "auto" }
                  : null
              }
            >
              <ColorPicker
                key={selectedOption}
                color={selectedOption}
                propertyName={details.key}
                presetColors={props.presetColors}
                sketchPickerCustomStyle={
                  translationStyles
                    ? {
                        position: "absolute",
                        left: "0px",
                        top: "-200px",
                        zIndex: 1,
                      }
                    : { position: "absolute", right: "0px", top: "-200px" }
                }
                colorPickerOuterBoxStyle={{}}
                colorPickerInnerBoxStyle={{
                  width: "18px",
                  height: "18px",
                  padding: "0px",
                  border: "none",
                  borderRadius: "0px",
                  margin: "0px",
                  left: "-22px",
                }}
                colorPickerInputStyle={{ display: "none" }}
                handleProperty={(arg1, arg2) =>
                  props.handleProperty(details.themeKey, arg1, arg2)
                }
              />
            </div>
          </Col>
        </div>
      ) : props.groupedColor && props.groupedColor === "true" ? (
        <div className={style.groupedColorChildDiv}>
          <Col className={style.headerBackgoundDecription} id='themeDropdownImage'>
            <div className={style.headerBackgoundDecriptionTitle} >
              {t(`${details.label}`)}
            </div>
            {details.imgSrc || details.imgSrc1 ? (
              <img
                src={
                  translationStyles
                    ? details?.imgSrc1?.default
                    : details?.imgSrc?.default
                }
                style={details.imgStyle}
                alt="img"
              />
            ) : null}
          </Col>
          <Col className={style.headerBackgroundColorBoxCol}>
            <div
              className={style.headerBackgroundColorBox}
              style={
                translationStyles
                  ? { marginLeft: "unset", marginRight: "auto" }
                  : null
              }
            >
              <ColorPicker
                key={selectedOption}
                color={selectedOption}
                propertyName={details.key}
                sketchPickerCustomStyle={
                  translationStyles
                    ? { position: "absolute", left: "0px", zIndex: 1 }
                    : { position: "absolute", right: "0px" }
                }
                colorPickerOuterBoxStyle={{}}
                colorPickerInnerBoxStyle={{
                  width: "18px",
                  height: "18px",
                  padding: "0px",
                  border: "none",
                  borderRadius: "0px",
                  margin: "0px",
                  left: "-22px",
                }}
                colorPickerInputStyle={{ display: "none" }}
                presetColors={props.presetColors}
                handleProperty={(arg1, arg2) =>
                  props.handleProperty(details.themeKey, arg1, arg2)
                }
              />
            </div>
          </Col>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default DropdownComponent;
